const PRINT_PLATE = 'printPlate';
const PRINT_AREA = 'printAreas';
const DIFFERENT_COLOR = 'variantWithDifferentColor';
const IS_LOADED = 'isLoaded';
const CURRENT_PRODUCT = 'currentProduct';

/**
 * This constant is quick and dirty fix to add no cache query param to our product images,
 * so we load always the original one from the server. When using speed kit it seems that
 * the images got intercept and an image with an adjusted resolution got delivered instead,
 * which breaks the coordinates of the print area placement.
 */
const NOCACHETIMESTAMP = new Date().getTime();

const getCurrentProductFromAvailabilities = articleInfo => {
  const product = articleInfo.availability.filter(
    product => product.articleNumber === articleInfo.articleNumber
  );
  return product.length ? product.shift() : {};
};

export default {
  articleNumber: state => state.info.articleNumber,
  availability: state => state.info.availability,
  composition: state => state.info.composition,
  currentColor: state => getCurrentProductFromAvailabilities(state.info).color,
  [CURRENT_PRODUCT]: state => getCurrentProductFromAvailabilities(state.info),
  [IS_LOADED]: state => state.isLoaded,
  price: state => state.price,
  image: state => side =>
    `${state.info.images[side].src}?v=${NOCACHETIMESTAMP}`,
  images: state => state.info.images,
  [PRINT_AREA]: state => side => state.info.printAreas[side],
  [PRINT_PLATE]: state => side => state.info.printPlate[side],
  title: state => state.info.title,
  availableColors: state => {
    const addedColors = [];
    const availableColors = [];
    state.info.availability
      .filter(variant => variant.active === true)
      .forEach(variant => {
        if (!addedColors.includes(variant.color.toLowerCase())) {
          availableColors.push({
            id: variant.colorId,
            label: variant.color,
            hex: variant.colorHex
          });
          addedColors.push(variant.color.toLowerCase());
        }
      });
    return availableColors;
  },
  selectedColor: state =>
    (state.info.articleNumber &&
      parseInt(state.info.articleNumber.replace(/.*?-c(\d+).*/, '$1'), 10)) ||
    0,
  [DIFFERENT_COLOR]: state => colorId => {
    const size = getCurrentProductFromAvailabilities(state.info).size;

    let availableVariant;

    state.info.availability
      .filter(variant => colorId === variant.colorId && true === variant.active)
      .some(variant => {
        if (undefined === availableVariant) {
          availableVariant = variant;
        }

        if (size === variant.size) {
          availableVariant = variant;

          return true;
        }

        return false;
      });

    return availableVariant.articleNumber;
  }
};

import { NAMESPACE } from './namespace';

export const GETTER_PRODUCT_PRINT_PLATE = `${NAMESPACE}${PRINT_PLATE}`;
export const GETTER_PRODUCT_PRINT_AREA = `${NAMESPACE}${PRINT_AREA}`;
export const GETTER_PRODUCT_DIFFERENT_COLOR = `${NAMESPACE}${DIFFERENT_COLOR}`;
export const GETTER_PRODUCT_IS_LOADED = `${NAMESPACE}${IS_LOADED}`;
export const GETTER_PRODUCT_CURRENT_PRODUCT = `${NAMESPACE}${CURRENT_PRODUCT}`;
